import React from 'react'
import ChatComponent from '../../../components/Chat'

function UserChats() {
    return (
        <div>
            <ChatComponent />
        </div>
    )
}

export default UserChats